/**
 * Created by henriquemasca on 9/30/19.
 */
import React, { Component } from "react";


class RegTimer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      seconds: 0,
      minutes: 0,
      hours: 0,
      days: 0,
      ends: this.props.ends,
      starts: this.props.starts
    };

    //let color;
    //let secondsRemainingToEnd;
    //let secondsRemainingToStart;
    //let secondsRemaining;
    //let intervalHandle;
  }

  updateSecondsRemaining = () => {

    let now = new Date();
    let now_gmt = now.getTime(); // + (now.getTimezoneOffset() * 60000);
    
    const new_ends = this.state.ends.replace('Z','Z');
    const new_starts = this.state.starts.replace('Z','Z');
    
    let countDowntoEnd = new Date(new_ends).getTime();
    let countDownToStart = new Date(new_starts).getTime();

    this.secondsRemainingToEnd = countDowntoEnd - now_gmt;
    this.secondsRemainingToStart = countDownToStart - now_gmt;

    if (this.secondsRemainingToStart > 0) {
      this.secondsRemaining = this.secondsRemainingToStart;
      this.color = 'red'
    } else {
      this.secondsRemaining = this.secondsRemainingToEnd;
      this.color = 'green'
    }

  };


  componentDidMount () {
      this.intervalHandle = setInterval(this.tick, 1000);
      this.updateSecondsRemaining();
  }



  renderTimer() {
  	
  	//if (this.secondsRemaining === 0) {
    	//
    	//	window.location.reload();
    	//
	  //}

    if (this.secondsRemaining > 0) {
        return (
            <div>
              <h4 style={{color: this.color }}>{this.state.days}d :{this.state.hours}h :{this.state.minutes}m :{this.state.seconds}s...</h4>
            </div>
        );
    } else {
	    return (
		    <div style={{color: 'red'}}>
			    Encerrado
		    </div>
	    )
    }
  }

  tick = () => {

    //let min = Math.floor(this.secondsRemaining / 60);
    //let sec = this.secondsRemaining - (min * 60);
    let days = Math.floor(this.secondsRemaining / (1000 * 60 * 60 * 24));
    let hours = Math.floor((this.secondsRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((this.secondsRemaining % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((this.secondsRemaining % (1000 * 60)) / 1000);

    this.setState({ minutes: minutes, seconds: seconds, days: days, hours: hours });

    if (seconds < 10) { this.setState({ seconds: "0" + seconds,}) }
    if (minutes < 10) { this.setState({ minutes: "0" + minutes, }) }
    if (hours < 10) { this.setState({ hours: "0" + hours, }) }
    if (days < 10) { this.setState({ days: "0" + days, }) }

    if (this.secondsRemaining < 0  ) {
      clearInterval(this.intervalHandle);
    } else {
      this.updateSecondsRemaining();
    }

  };
  
  showDate = (datestr) => {
  	
  	//const new_date_str = datestr.replace('T',' ') + ' GMT';
  	
  	//console.log(new_date_str);
  	
  	//const d = new Date(datestr);
  	const d = new Date(datestr);
  	//console.log('k',k);
  	
  	//console.log('d', d);
	  
  	//const d_local_show = new Date(d.getTime()  - (d.getTimezoneOffset() * 60000));
  	//console.log('d_local_show', d_local_show);
	  
	  const options = { year: 'numeric', month: 'numeric', day: 'numeric',
	                    hour: 'numeric', minute: 'numeric'};
  	
  	//return d_local_show.toLocaleDateString('pt-BR', options);
  	return d.toLocaleDateString('pt-BR', options);
	  
  	
  };

  render() {

    return (
      <div>
        <div className="row">

          <div className="col-md-12">
              
              <div style={{color: this.color}}>
                Início do leilão: {this.showDate(this.state.starts)}
              </div>
	          
	            {this.renderTimer()}
              
              <div hidden={this.color === 'red'}>
	              Encerramento : {this.showDate(this.state.ends)}
              </div>
          </div>
        </div>
      </div>
    );
  }
}


export default RegTimer;



// WEBPACK FOOTER //
// ./src/components/RegTimer/index.js